(function ($) {
	'use strict';

	$(function () {
		$('.js-quotes-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-link-gallery-nav', sliderContainer);
			const numSlides = sliderEl.querySelectorAll('.js-carousel-slide').length;

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				slidesPerView: 1,
				centeredSlides: false,
				navigation: false,
				slidesPerGroup: 1,
				spaceBetween: 20,

				on: {
					beforeInit: function () {
						if (numSlides <= 1) {
							navParent.addClass('carousel-nav--hidden');
						}
					}
				}
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
